import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { OrderDeleteCommand, OrderDeleteCommandBase } from '@skylab-shared/business';
import { DeleteResponse, HttpService } from '@skylab-shared/core';

@CommandHandlerFor(OrderDeleteCommand)
@Injectable({ providedIn: 'root'})
export class OrderDeleteCommandHandler {
	private commandHandler: OrderDeleteCommandBase;
	public constructor(
		@Inject(Http) http: HttpService
	) {
		this.commandHandler = new OrderDeleteCommandBase(http);
	}

	public async handleAsync(query: OrderDeleteCommand): Promise<DeleteResponse> {
		return await this.commandHandler.handleAsync(query);
	}
}
